module.exports = __webpack_public_path__ + "59c3f0a575b040d8bfb9902aa2c0a07f.svg";